import { render, staticRenderFns } from "./THYFareFeatures.vue?vue&type=template&id=bba3975a&scoped=true&"
import script from "./THYFareFeatures.vue?vue&type=script&lang=js&"
export * from "./THYFareFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3975a",
  null
  
)

export default component.exports